
/* ESPOVIA — GLOBAL MOTION */

(function () {
  'use strict';

  const styleId = 'espovia-global-motion-style';

  function installStyles() {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;

    style.textContent = `
      @keyframes espoviaFloat {
        0%, 100% {
          transform: translate3d(0, 0, 0) scale(1.015);
        }
        50% {
          transform: translate3d(0, -18px, 0) scale(1.045);
        }
      }

      .espovia-motion-float {
        animation: espoviaFloat 5s ease-in-out infinite;
        transform-origin: center;
      }

      .espovia-motion-reveal {
        opacity: 1;
        transform: translateY(0);
        transition:
          opacity 800ms ease,
          transform 800ms cubic-bezier(.2,.7,.2,1);
      }

      .espovia-motion-ready .espovia-motion-reveal:not(.espovia-motion-visible) {
        opacity: 0;
        transform: translateY(30px);
      }

      .espovia-motion-ready .espovia-motion-reveal.espovia-motion-visible {
        opacity: 1;
        transform: translateY(0);
      }

      @media (prefers-reduced-motion: reduce) {
        .espovia-motion-float {
          animation: none !important;
        }

        .espovia-motion-reveal {
          opacity: 1 !important;
          transform: none !important;
          transition: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function initMotion() {
    installStyles();

    const sections = document.querySelectorAll(
      '.espovia-serum, .espovia-cream'
    );

    if (!sections.length) return;

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    const observer = !reducedMotion &&
      'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle(
              'espovia-motion-visible',
              entry.isIntersecting
            );
          });
        }, {
          threshold: 0.12
        })
      : null;

    sections.forEach(function (section) {
      if (section.dataset.espoviaMotionInit === 'true') return;

      section.dataset.espoviaMotionInit = 'true';

      const image = section.querySelector('img');

      if (image && !reducedMotion) {
        image.classList.add('espovia-motion-float');
      }

      const targets = [
        section.querySelector('.espovia-serum-image, .espovia-cream-image'),
        section.querySelector('.espovia-serum-content, .espovia-cream-content')
      ].filter(Boolean);

      targets.forEach(function (target) {
        target.classList.add('espovia-motion-reveal');

        if (observer) {
          observer.observe(target);
        } else {
          target.classList.add('espovia-motion-visible');
        }
      });
    });

    document.documentElement.classList.add(
      'espovia-motion-ready'
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMotion);
  } else {
    initMotion();
  }

  document.addEventListener('shopify:section:load', initMotion);
})();
